module.exports = __webpack_public_path__ + "img/program-regionalny-logo.52bab74c.png";